export default {
      id: "icon-person-usage",
      viewBox: "0 0 17.069 20.983",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-person",
      toString: function () {
        return this.url;
      }
    }